import React, { useState, useEffect } from 'react'
import { Route, Switch, Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { Layout } from 'app/theme/layout'
import CaseStudySlider from './CaseStudySlider.js'
import { useQuery } from 'jsonapi-react'
import NotFoundPage from 'app/pages/NotFoundPage'
import HtmlContent from 'app/theme/HtmlContent'
import useLeadModal from './useLeadModal'

export default function CaseStudy(props) {
  const { Modal, openModal } = useLeadModal()

  const query = useQuery(['case_studies', {
    include: 'photos',
    filter: {
      slug: props.match.params.slug
    },
    extra_fields: {
      case_studies: ['prev_slug', 'next_slug']
    }
  }])

  if (query.isLoading) {
    return null
  }

  if (!query.data.length) {
    return <NotFoundPage />
  }

  const study = query.data[0]

  return (
    <Layout>
      <Helmet>
        <title>{study.title} - Agency Case Study - Roaming Hunger</title>
        <meta name="description" content={study.headline}></meta>
        <meta name="og:title" content={`${study.title} - Agency Case Study - Roaming Hunger`}></meta>
      </Helmet>
      <Modal />
      <div className="container py-12">
        <div className="w-full lg:w-2/3 mx-auto">
          <h4 className="font-semibold uppercase tracking-wider text-gray-600">{study.title}</h4>
          <h1 className="mb-5 text-5xl text-blue font-platform leading-none">{study.product}</h1>
          <CaseStudySlider
            photos={study.photos}
          />
          <h2 className="mb-3 text-2xl mt-12">{study.headline}</h2>
          <HtmlContent
            className="text-lg font-light font-national"
            content={study.description}
          />
          
          <div className="w-full flex mt-6">
            { study.prev_slug && 
              <Link to={`/experiential-marketing-agency/${study.prev_slug}/`} className='w-full'>
                <button className="w-full bg-gray-200 border-b-2 py-3 px-4 text-center">
                  {'<'} Prev
                </button>
              </Link>
            }

            <button  className="w-full bg-gray-200 border-b-2 mx-3 py-3 px-4 text-center"><Link to="/experiential-marketing-agency/">Back to Agency</Link></button>

            { study.next_slug && 
              <Link to={`/experiential-marketing-agency/${study.next_slug}/`} className='w-full'>
                <button className="w-full bg-gray-200 border-b-2 py-3 px-4 text-center">
                  Next {'>'}
                </button>
              </Link>
            }
          </div>
         
        </div>
      </div>
      <div className="bg-white py-16 text-center text-2xl">
        <button
          className="block btn btn-blue font-platform py-3 px-10 m-auto"
          onClick={openModal}
        >
          Get Started
        </button>
        <a href="mailto:agency@roaminghunger.com" className="block pt-3 text-blue font-national font-light">agency@roaminghunger.com</a>
        <a href="tel:+18885728756" className="block pt-3 text-blue font-national font-light">(888) 572-8756</a>
      </div>
    </Layout>
  )
}
